import React from "react";
import "../styles/gydeHealthSection.css";
import dummy from "../asserts/david.png";
import picture1 from "../asserts/Picture1.png";
import picture2 from "../asserts/Picture2.png";
import picture3 from "../asserts/Picture3.png";
import sports from "../asserts/sports.png";

const GydeHealthSection = () => {
  return (
    <>
      <section className="health-section">
        <h1 className="health-bg-title">The Applications</h1>

        <div className="health-left">
          <p className="health-small-title">HEALTH & FITNESS</p>
          <h2>Gyde Health</h2>

          <p className="health-desc">
            AI-powered fitness app that is a trainer
            <br />
            your pocket!
          </p>

          <ul>
            <li>Easily assessable training for all</li>
            <li>Workout anywhere</li>
            <li>Live form and posture guidance</li>
            <li>Audio+visual guidance</li>
            <li>Long-term Progress Tracking</li>
          </ul>
        </div>

        <div className="health-images">
          <img src={dummy} alt="app screen" className="middle-img" />
          <img src={picture1} alt="app screen" />
          <img src={picture2} alt="app screen" className="middle-img" />
          <img src={picture3} alt="app screen" />
        </div>
      </section>

      <section className="Video-links">
        <div className="Video-player">
          <h2>Discover Our Solutions</h2>

          <div className="Video-player-row">
            <iframe
              src="https://www.youtube.com/embed/GdRBS7QR-kY?controls=0&modestbranding=1&rel=0&mute=1"
              title="Surya Namaskar"
              allowFullScreen
            ></iframe>

            <iframe
              src="https://www.youtube.com/embed/M7TrIva20uw?controls=0&modestbranding=1&rel=0&mute=1"
              title="Product Flow"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        <div className="Left-texts">
          <h2>Explore More Workouts</h2>

          <a
            href="https://youtu.be/GdRBS7QR-kY"
            target="_blank"
            rel="noopener noreferrer"
          >
            Surya Namaskar
          </a>

          <a
            href="https://youtube.com/shorts/4ZRuHaORC6M"
            target="_blank"
            rel="noopener noreferrer"
          >
            Pushups
          </a>

          <a
            href="https://youtube.com/shorts/7IamqEkE7S4"
            target="_blank"
            rel="noopener noreferrer"
          >
            Elbow Plank
          </a>

          <a
            href="https://youtu.be/M7TrIva20uw"
            target="_blank"
            rel="noopener noreferrer"
          >
            Product Flow
          </a>

          <a
            href="https://youtube.com/shorts/K7YjVK_9Pzc"
            target="_blank"
            rel="noopener noreferrer"
          >
            Squats
          </a>
        </div>
      </section>

      <section className="sports-section">
        <div className="sports-left">
          <p className="sports-small-title">SPOTS COACHING</p>
          <h2>Gyde sports</h2>

          <p className="sports-desc">
            Movement intelligence designed to support
            <br />
            coaches and athlete development.
          </p>

          <ul>
            <li>Athlete Performance Analysis</li>
            <li>Coach Assistance</li>
            <li>Skill Development</li>
            <li>Training Insights</li>
          </ul>

          <p className="development-text">In development</p>
        </div>

        <div className="sports-image-box">
          <img src={sports} alt="Gyde sports" />
        </div>

        {/* <div className="sports-corner-line"></div> */}
      </section>
    </>
  );
};

export default GydeHealthSection;
